import axios from "axios";
import { servicePath } from "../../utility/data";


export const addLiablity = async (liablityData, accessToken) => {
    const payload = {
        "name": liablityData.name,
        "included_in": String(liablityData.inclusion.id),
        "debt_type": liablityData.debtType,
        "date": liablityData.date,
        "linked_with": liablityData.linkedWith ? liablityData.linkedWith : "string",
        "rank": liablityData.firstRank ? liablityData.firstRank : 0,
        "interest": liablityData.Interest ? liablityData.Interest : 0,
        "period": liablityData.period ? liablityData.period : 0,
        };
  
    try {
      const response = await axios.post(`${servicePath}/liability`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error :', error);
      throw error;
    }
  };